export default __webpack_public_path__ + "static/media/case2-2 (2).3c767a7c.png";